import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';

export const MainMenuRegionalDisplay = ({ regionsPage }) => {
    const selectedRegion = useSelector((state) => state.selectedRegion);

    const displayedRegion = selectedRegion
        ? selectedRegion.regionName
        : getTranslation(`region.selector.selectACountryOrRegion`);
    return (
        <div className="sub-menu__item">
            <a
                href={regionsPage}
                className="sub-menu__link sub-menu__regional-display-link-wrapper"
            >
                <SvgIcon
                    className="sub-menu__regional-display-icon"
                    icon="globe"
                />
                <div>
                    <p className="">{displayedRegion}</p>
                    <p className="sub-menu__regional-display-link">
                        {getTranslation(`region.selector.changeLocation`)}
                    </p>
                </div>
            </a>
        </div>
    );
};

MainMenuRegionalDisplay.propTypes = {
    regionsPage: PropTypes.string
};
